import type { RealtimeServerFrame } from '@aroo/shared';
import { createContext, useContext } from 'react';

export type RealtimeStatus = 'connecting' | 'open' | 'closed';
export type RealtimeEvent = RealtimeServerFrame | { type: 'reconnected' };

export interface RealtimeApi {
  status: RealtimeStatus;
  /** Ref-counted: the socket stays subscribed while anyone on the page wants the channel. */
  subscribe: (channelId: string) => () => void;
  /** Every frame (and `reconnected`). Returns an unsubscribe function. */
  listen: (handler: (e: RealtimeEvent) => void) => () => void;
}

export const RealtimeContext = createContext<RealtimeApi | null>(null);

/** Null outside the signed-in shell (e.g. tests); callers then simply get no live updates. */
export function useRealtime(): RealtimeApi | null {
  return useContext(RealtimeContext);
}
